<template>
  <v-edit-dialog
    v-if="canEdit"
    :return-value.sync="workingValue"
    large
    persistent
    @save="saveChange">
    {{ isPrice && workingValue ? '$' + workingValue : workingValue }}
    <template v-slot:input>
      <div class="mt-4 text-h6">
        {{ title }}
      </div>
      <v-autocomplete
        v-if="isDropdown"
        v-model="workingValue"
        :items="items"
        single-line
      ></v-autocomplete>
      <v-text-field
        v-else-if="isPrice"
        v-model="workingValue"
        :clearable="clearable"
        type="number"
        prefix="$"
        step="0.01"
        single-line
        autofocus
      ></v-text-field>
      <v-menu
        v-else-if="isDate"
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        left
        min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="workingValue"
            placeholder="Click to select Date"
            :clearable="clearable"
            readonly
            v-bind="attrs"
            v-on="on">
          </v-text-field>
        </template>
        <v-date-picker
          v-model="parsedDate"
          no-title
          scrollable>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(workingValue)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
      <v-text-field
        v-else
        v-model="workingValue"
        :clearable="clearable"
        label="Edit"
        single-line
        autofocus
      ></v-text-field>
    </template>
  </v-edit-dialog>
  <div
    v-else>
    {{ isPrice && value ? '$' + value : value }}
  </div>
</template>
<script>

export default {
  name: 'Edit-Dialog-Popup',
  data () {
    return {
      workingValue: this.value,
      menu: false
    }
  },
  props: {
    title: String,
    value: [String, Number],
    items: Array,
    clearable: {
      type: Boolean,
      default: false
    },
    isPrice: {
      type: Boolean,
      default: false
    },
    isDate: {
      type: Boolean,
      default: false
    },
    isDropdown: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler (newValue) {
        this.workingValue = newValue
      }
    }
  },
  computed: {
    computedDate () {
      if (this.isDate) {
        return this.formatDate(this.workingValue)
      }
    },
    parsedDate: {
      get () {
        if (this.isDate) {
          return this.parseDate(this.workingValue)
        }
      },
      set (newValue) {
        this.workingValue = this.formatDate(newValue)
      }
    }
  },
  methods: {
    saveChange() {
      this.$emit('update:value', this.workingValue)
      this.$emit('save')
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/items/edit_dialog.vue